module.exports = __webpack_public_path__ + "img/Help-icon.c3c65869.svg";